import { useEffect, useState } from "react";
import api from "../../api/axios";

import {
  FaMoneyBillWave,
  FaFileInvoiceDollar,
  FaPlane,
  FaUtensils,
  FaLaptop,
  FaBuilding,
  FaPlus,
  FaReceipt,
} from "react-icons/fa";

import "./../../assets/css/Expenses/ExpensesDynamic.css";

const getExpenseIcon = (type = "") => {
  const t = (type || "").toLowerCase();
  if (t.includes("travel") || t.includes("flight") || t.includes("taxi")) return <FaPlane />;
  if (t.includes("food") || t.includes("meal") || t.includes("dining")) return <FaUtensils />;
  if (t.includes("client meeting") || t.includes("meeting")) return <FaFileInvoiceDollar />;
  if (t.includes("demo") || t.includes("training") || t.includes("software")) return <FaLaptop />;
  if (t.includes("vendor")) return <FaBuilding />;
  return <FaMoneyBillWave />;
};

const getExpenseTypeClass = (type = "") => {
  const t = (type || "").toLowerCase();
  if (t.includes("travel")) return "travel";
  if (t.includes("food") || t.includes("meal")) return "food";
  if (t.includes("meeting")) return "meeting";
  if (t.includes("demo") || t.includes("training")) return "demo";
  if (t.includes("vendor")) return "vendor";
  return "other";
};

export default function ExpensesList({
  leadId,
  dealId,
  refreshKey = 0,
  onAddExpense,
}) {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        setLoading(true);

        let url = "";

        if (dealId) {
          url = `/expense/deal/${dealId}`;
        } else if (leadId) {
          url = `/expense/lead/${leadId}`;
        } else {
          setExpenses([]);
          return;
        }

        const res = await api.get(url);
        setExpenses(res.data || []);
      } catch (err) {
        console.error("Expense fetch error:", err);
        setExpenses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchExpenses();
  }, [leadId, dealId, refreshKey]);

  const totalAmount = expenses.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0
  );

  return (
    <div className="expense-list">
      {/* SUMMARY STAT CARD */}
      <div className="expense-summary-card">
        <div className="expense-header">
          <div className="expense-header-left">
            <div className="expense-header-icon-box">
              <FaFileInvoiceDollar className="expense-header-icon" />
            </div>
            <div className="expense-header-title-box">
              <h3>Expenses</h3>
              <span className="expense-count-pill">
                {expenses.length} {expenses.length === 1 ? "entry" : "entries"}
              </span>
            </div>
          </div>

          <div className="expense-header-right">
            {onAddExpense && (
              <button
                type="button"
                className="expense-add-btn"
                onClick={onAddExpense}
                title="Log New Expense"
              >
                <FaPlus size={10} />
                <span>Log Expense</span>
              </button>
            )}
          </div>
        </div>

        <div className="expense-stats-row">
          <div className="expense-stat-pill">
            <span className="expense-stat-label">Total Expense</span>
            <h3 className="expense-total">
              ₹{totalAmount.toLocaleString("en-IN")}
            </h3>
          </div>

          <div className="expense-stat-pill">
            <span className="expense-stat-label">Logged Records</span>
            <span className="expense-stat-val">{expenses.length}</span>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="expense-empty">Loading...</div>
      ) : expenses.length === 0 ? (
        <div className="expense-empty">
          <div className="expense-empty-icon">
            <FaReceipt />
          </div>
          <div className="expense-empty-title">No expenses found</div>
          <p className="expense-empty-desc">
            No expenses have been recorded for this {dealId ? "deal" : "lead"} yet.
          </p>
          {onAddExpense && (
            <button
              type="button"
              className="expense-add-btn"
              onClick={onAddExpense}
              style={{ marginTop: "6px" }}
            >
              <FaPlus size={10} />
              <span>Record First Expense</span>
            </button>
          )}
        </div>
      ) : (
        <div className="expense-items-container">
          {expenses.map((exp) => (
            <div className="expense-item" key={exp.id}>
              <div
                className={`expense-icon ${getExpenseTypeClass(
                  exp.expense_type
                )}`}
              >
                {getExpenseIcon(exp.expense_type)}
              </div>

              <div className="expense-content">
                <div className="expense-row">
                  <div className="expense-info">
                    <h4>{exp.expense_type}</h4>

                    <p>
                      {exp.remarks || "No remarks"}
                      {" • "}
                      {exp.expense_date
                        ? new Date(exp.expense_date).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }
                          )
                        : "-"}
                    </p>
                  </div>

                  <span className="expense-price">
                    ₹{Number(exp.amount || 0).toLocaleString("en-IN")}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}